'use client';
import { usePathname } from 'next/navigation';
import NavSearchBar from './NavSearchBar';
import type { MenuNode } from '@/lib/navigation';

type Props = {
  children: React.ReactNode;
  menuTree: MenuNode[];
  rootAssignments?: MenuNode['assignments'];
};

export default function PublicShell({ children, menuTree, rootAssignments }: Props) {
  const pathname = usePathname() || '';
  if (pathname.startsWith('/report-runs/')) return <>{children}</>;
  const isAdmin = pathname.startsWith('/admin');
  if (isAdmin) {
    return (
      <>
        <NavSearchBar tree={menuTree} rootAssignments={rootAssignments} />
        {children}
      </>
    );
  }
  const isEmbed = pathname.startsWith('/x/');
  const shellClass = `public-shell${isEmbed ? ' is-embed' : ''}`;
  const contentClass = `public-content${isEmbed ? ' is-embed' : ''}`;
  return (
    <>
      <NavSearchBar tree={menuTree} rootAssignments={rootAssignments} />
      <div className={shellClass}>
        <div className={contentClass}>{children}</div>
      </div>
    </>
  );
}
